function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_135",
  "data-name": "Group 135",
  transform: "translate(-959 -99)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_133",
  "data-name": "Group 133"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_134",
  "data-name": "Group 134"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 959, 99)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_158-2",
  "data-name": "Ellipse 158",
  transform: "translate(9 6)",
  fill: "rgba(255,255,255,0)",
  stroke: "#fff",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "bg",
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "arrow",
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  fill: "none"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "ctrl-right",
  transform: "translate(980.032 112.599)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M8,1l5.067,6.966L8,14.933",
  transform: "translate(-8 -1)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2
})));

function SvgCircleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRight);
export default __webpack_public_path__ + "static/media/circle-right.d6c51295.svg";
export { ForwardRef as ReactComponent };